import { commonMessages } from "@/messages/common";

export const authMessages = {
  documentTitle: {
    login: "Sign in — NetShield Internal Admin",
    verifyOtp: "Check your email — NetShield Internal Admin",
    forgotPassword: "Reset password — NetShield Internal Admin",
  },
  brand: commonMessages.brand,
  login: {
    twoStepPillAriaLabel: "Two-step secure sign-in",
    twoStepPill: "Two-step secure sign-in",
    sessionExpired:
      "Your session ended due to inactivity. Sign in again to continue.",
    title: "Sign in",
    subtitle: "NetShield staff only.",
    workEmail: "Work email",
    emailPlaceholder: "you@netshieldtech.com",
    password: "Password",
    passwordPlaceholder: "••••••••••••",
    showPassword: "Show password",
    hidePassword: "Hide password",
    submit: "Sign in",
    submitting: "Signing in…",
    signInFailed: "Sign-in failed. Please try again.",
    forgotPassword: "Forgot password?",
    forgotPasswordSubmitting: "Sending reset link…",
    forgotPasswordEmailRequired:
      "Enter your work email above, then try again.",
    forgotPasswordFailed: "Could not send the reset email. Please try again.",
    passwordResetSuccess: "Your password has been reset. Sign in with your new password.",
  },
  forgotPassword: {
    title: "Reset password",
    subtitleBeforeEmail: "We sent a reset token to",
    subtitleAfterEmail: ". Copy the token from the email and choose a new password below.",
    token: "Reset token",
    tokenPlaceholder: "Paste token from email",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    passwordHint: "At least 12 characters.",
    submit: "Reset password",
    submitting: "Resetting password…",
    resetFailed: "Could not reset your password. Please try again.",
    passwordMismatch: "Passwords do not match.",
    passwordTooShort: "Password must be at least 12 characters.",
    tokenRequired: "Enter the reset token from your email.",
    backToSignIn: "Back to sign-in",
  },
  verifyOtp: {
    title: "Check your email",
    subtitleBeforeEmail: "We sent a 6-digit code to",
    subtitleAfterEmail: ".",
    codeValidity: (minutes: number) =>
      `The code is valid for ${minutes} minute${minutes === 1 ? "" : "s"}.`,
    stepBanner: "Step 2 of 2 · Email OTP",
    digitAriaLabel: (index: number) => `OTP digit ${index}`,
    submit: "Verify and sign in",
    submitting: "Verifying…",
    verificationFailed: "Verification failed. Please try again.",
    resendPrompt: "Didn't get the code",
    resendHelp: "Allow 60 seconds for delivery · Check spam folder ",
    resendHelpAriaLabel: "Code delivery help",
    resendCooldown: (seconds: number) => `Resend in ${seconds}s`,
    resend: "Resend",
    resending: "Resending…",
    resendFailed: "Failed to resend code. Please try again.",
    resendExhausted: "No resends remaining",
    troubleshootingWithAttempts: (remaining: number) =>
      `You have ${remaining} attempt${remaining === 1 ? "" : "s"} remaining.`,
    backToSignIn: "Back to sign-in",
  },
  sessionExpiry: {
    title: "Session inactive",
    body: {
      beforeIdle: "You have been inactive for",
      afterIdle: ". Your session will end in",
      afterRemaining: "unless you stay signed in.",
    },
    staySignedIn: "Stay signed in",
    signOut: "Sign out",
  },
  userMenu: {
    defaultRole: "Operations Lead · admin",
    logout: "Log out",
    accountMenuAriaLabel: "Account menu",
  },
} as const;
